export default __webpack_public_path__ + "static/media/mode-53.5c895158.svg";